export const InfoIcon = ({ active = false }: { active: boolean }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 13.3333C3.55719 11.6817 5.67134 10.6667 8 10.6667C10.3287 10.6667 12.4428 11.6817 14 13.3333M11 5C11 6.65685 9.65685 8 8 8C6.34315 8 5 6.65685 5 5C5 3.34315 6.34315 2 8 2C9.65685 2 11 3.34315 11 5Z"
        stroke={active ? "white" : "#667085"}
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const EmailIcon = ({ active = false }: { active: boolean }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.3335 4.66699L6.77678 8.47729C7.21756 8.78583 7.43795 8.94011 7.67767 8.99986C7.88943 9.05265 8.1109 9.05265 8.32265 8.99986C8.56238 8.94011 8.78277 8.78583 9.22355 8.47729L14.6668 4.66699M4.5335 13.3337H11.4668C12.5869 13.3337 13.147 13.3337 13.5748 13.1157C13.9511 12.9239 14.2571 12.618 14.4488 12.2416C14.6668 11.8138 14.6668 11.2538 14.6668 10.1337V5.86699C14.6668 4.74689 14.6668 4.18683 14.4488 3.75901C14.2571 3.38269 13.9511 3.07673 13.5748 2.88498C13.147 2.66699 12.5869 2.66699 11.4668 2.66699H4.5335C3.41339 2.66699 2.85334 2.66699 2.42552 2.88498C2.04919 3.07673 1.74323 3.38269 1.55148 3.75901C1.3335 4.18683 1.3335 4.74689 1.3335 5.86699V10.1337C1.3335 11.2538 1.3335 11.8138 1.55148 12.2416C1.74323 12.618 2.04919 12.9239 2.42552 13.1157C2.85334 13.3337 3.41339 13.3337 4.5335 13.3337Z"
        stroke={active ? "white" : "#667085"}
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const PasswordIcon = ({ active = false }: { active: boolean }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.6665 6.66667V5.33333C4.6665 3.49238 6.15889 2 7.99984 2C9.36672 2 10.5414 2.82273 11.0558 4M7.99984 9.66667V11M5.8665 14H10.1332C11.2533 14 11.8133 14 12.2412 13.782C12.6175 13.5903 12.9234 13.2843 13.1152 12.908C13.3332 12.4802 13.3332 11.9201 13.3332 10.8V9.86667C13.3332 8.74656 13.3332 8.18651 13.1152 7.75869C12.9234 7.38236 12.6175 7.0764 12.2412 6.88465C11.8133 6.66667 11.2533 6.66667 10.1332 6.66667H5.8665C4.7464 6.66667 4.18635 6.66667 3.75852 6.88465C3.3822 7.0764 3.07624 7.38236 2.88449 7.75869C2.6665 8.18651 2.6665 8.74656 2.6665 9.86667V10.8C2.6665 11.9201 2.6665 12.4802 2.88449 12.908C3.07624 13.2843 3.3822 13.5903 3.75852 13.782C4.18635 14 4.7464 14 5.8665 14Z"
        stroke={active ? "white" : "#667085"}
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const OrderIcon = ({ active = false }: { active: boolean }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.33317 7.33301H5.33317M6.6665 9.99967H5.33317M10.6665 4.66634H5.33317M13.3332 4.53301V11.4663C13.3332 12.5864 13.3332 13.1465 13.1152 13.5743C12.9234 13.9506 12.6175 14.2566 12.2412 14.4484C11.8133 14.6663 11.2533 14.6663 10.1332 14.6663H5.8665C4.7464 14.6663 4.18635 14.6663 3.75852 14.4484C3.3822 14.2566 3.07624 13.9506 2.88449 13.5743C2.6665 13.1465 2.6665 12.5864 2.6665 11.4663V4.53301C2.6665 3.4129 2.6665 2.85285 2.88449 2.42503C3.07624 2.0487 3.3822 1.74274 3.75852 1.55099C4.18635 1.33301 4.7464 1.33301 5.8665 1.33301H10.1332C11.2533 1.33301 11.8133 1.33301 12.2412 1.55099C12.6175 1.74274 12.9234 2.0487 13.1152 2.42503C13.3332 2.85285 13.3332 3.4129 13.3332 4.53301Z"
        stroke={active ? "white" : "#667085"}
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const TagsIcon = ({ active = false }: { active: boolean }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.33316 2L4.33316 14M11.6665 2L9.66648 14M13.6665 5.33333H2.33317M12.9998 10.6667H1.6665"
        stroke={active ? "white" : "#667085"}
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const SocialIcon = ({ active = false }: { active: boolean }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.3335 9.33333L14.6668 9.33333M5.3335 14H10.6668M4.5335 12H11.4668C12.5869 12 13.147 12 13.5748 11.782C13.9511 11.5903 14.2571 11.2843 14.4488 10.908C14.6668 10.4802 14.6668 9.92011 14.6668 8.8V5.2C14.6668 4.0799 14.6668 3.51984 14.4488 3.09202C14.2571 2.71569 13.9511 2.40973 13.5748 2.21799C13.147 2 12.5869 2 11.4668 2H4.5335C3.41339 2 2.85334 2 2.42552 2.21799C2.04919 2.40973 1.74323 2.71569 1.55148 3.09202C1.3335 3.51984 1.3335 4.07989 1.3335 5.2V8.8C1.3335 9.92011 1.3335 10.4802 1.55148 10.908C1.74323 11.2843 2.04919 11.5903 2.42552 11.782C2.85334 12 3.41339 12 4.5335 12Z"
        stroke={active ? "white" : "#667085"}
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const EditProfPictureIcon = () => {
  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="36" height="36" rx="18" fill="#039EF2" />
      <path
        d="M22.9997 16.3333L19.6664 12.9999M10.083 25.9166L12.9033 25.6032C13.2479 25.5649 13.4202 25.5458 13.5812 25.4937C13.7241 25.4474 13.86 25.3821 13.9854 25.2994C14.1267 25.2062 14.2493 25.0836 14.4944 24.8385L25.4997 13.8333C26.4202 12.9128 26.4202 11.4204 25.4997 10.4999C24.5792 9.57945 23.0868 9.57945 22.1664 10.4999L11.1611 21.5052C10.916 21.7503 10.7934 21.8729 10.7002 22.0142C10.6175 22.1396 10.5522 22.2755 10.5059 22.4184C10.4538 22.5794 10.4347 22.7517 10.3964 23.0963L10.083 25.9166Z"
        stroke="white"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const EditIcon = () => {
  return (
    <svg
      width="34"
      height="34"
      viewBox="0 0 34 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="34" height="34" rx="17" fill="#039EF2" />
      <path
        d="M9.5 13.7763C9.5 12.6572 10.4072 11.75 11.5263 11.75C12.1078 11.75 12.624 11.3779 12.8079 10.8263L12.875 10.625C12.9066 10.5301 12.9225 10.4826 12.9394 10.4405C13.1555 9.90284 13.662 9.53777 14.2405 9.50274C14.2858 9.5 14.3358 9.5 14.4359 9.5H19.5641C19.6642 9.5 19.7142 9.5 19.7595 9.50274C20.338 9.53777 20.8445 9.90284 21.0606 10.4405C21.0775 10.4826 21.0934 10.5301 21.125 10.625L21.1921 10.8263C21.376 11.3779 21.8922 11.75 22.4737 11.75C23.5928 11.75 24.5 12.6572 24.5 13.7763V20.15C24.5 21.4101 24.5 22.0402 24.2548 22.5215C24.039 22.9448 23.6948 23.289 23.2715 23.5048C22.7902 23.75 22.1601 23.75 20.9 23.75H13.1C11.8399 23.75 11.2098 23.75 10.7285 23.5048C10.3052 23.289 9.96095 22.9448 9.74524 22.5215C9.5 22.0402 9.5 21.4101 9.5 20.15V13.7763Z"
        stroke="white"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M17 20.375C18.864 20.375 20.375 18.864 20.375 17C20.375 15.136 18.864 13.625 17 13.625C15.136 13.625 13.625 15.136 13.625 17C13.625 18.864 15.136 20.375 17 20.375Z"
        stroke="white"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const EditGamerIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="stroke-black dark:stroke-white"
    >
      <path
        d="M7.99998 13.3332H14M2 13.3332H3.11636C3.44248 13.3332 3.60554 13.3332 3.75899 13.2963C3.89504 13.2637 4.0251 13.2098 4.1444 13.1367C4.27895 13.0542 4.39425 12.9389 4.62486 12.7083L13 4.33316C13.5523 3.78087 13.5523 2.88544 13 2.33316C12.4477 1.78087 11.5523 1.78087 11 2.33316L2.62484 10.7083C2.39424 10.9389 2.27894 11.0542 2.19648 11.1888C2.12338 11.3081 2.0695 11.4381 2.03684 11.5742C2 11.7276 2 11.8907 2 12.2168V13.3332Z"
        stroke-width="1.33333"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const DeleteIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="stroke-black dark:stroke-white"
    >
      <path
        d="M10.6667 3.99967V3.46634C10.6667 2.7196 10.6667 2.34624 10.5213 2.06102C10.3935 1.81014 10.1895 1.60616 9.93865 1.47833C9.65344 1.33301 9.28007 1.33301 8.53333 1.33301H7.46667C6.71993 1.33301 6.34656 1.33301 6.06135 1.47833C5.81046 1.60616 5.60649 1.81014 5.47866 2.06102C5.33333 2.34624 5.33333 2.7196 5.33333 3.46634V3.99967M2 3.99967H14M12.6667 3.99967V11.4663C12.6667 12.5864 12.6667 13.1465 12.4487 13.5743C12.2569 13.9506 11.951 14.2566 11.5746 14.4484C11.1468 14.6663 10.5868 14.6663 9.46667 14.6663H6.53333C5.41323 14.6663 4.85318 14.6663 4.42535 14.4484C4.04903 14.2566 3.74307 13.9506 3.55132 13.5743C3.33333 13.1465 3.33333 12.5864 3.33333 11.4663V3.99967"
        stroke-width="1.33333"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const GoogleIcon = () => {
  return (
    <svg
      width="50"
      height="50"
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M46.8778 25.4859C46.8778 23.6873 46.7288 22.3748 46.4065 21.0137H25.4492V29.1316H37.7507C37.5028 31.1491 36.1635 34.1873 33.1872 36.2288L33.1455 36.5006L39.7718 41.5313L40.2309 41.5762C44.4471 37.7601 46.8778 32.1455 46.8778 25.4859Z"
        fill="#4285F4"
      />
      <path
        d="M25.4483 46.875C31.4749 46.875 36.5344 44.9304 40.2299 41.5763L33.1863 36.2289C31.3014 37.5171 28.7716 38.4164 25.4483 38.4164C19.5455 38.4164 14.5357 34.6005 12.7498 29.3262L12.488 29.348L5.59792 34.5737L5.50781 34.8192C9.17839 41.965 16.7181 46.875 25.4483 46.875Z"
        fill="#34A853"
      />
      <path
        d="M12.7518 29.3266C12.2806 27.9655 12.0079 26.507 12.0079 25.0002C12.0079 23.4931 12.2806 22.0348 12.727 20.6737L12.7145 20.3839L5.73806 15.0742L5.5098 15.1806C3.99697 18.1459 3.12891 21.4759 3.12891 25.0002C3.12891 28.5244 3.99697 31.8542 5.5098 34.8195L12.7518 29.3266Z"
        fill="#FBBC05"
      />
      <path
        d="M25.4484 11.5833C29.6398 11.5833 32.4671 13.3576 34.0793 14.8403L40.3789 8.8125C36.5099 5.2882 31.4751 3.125 25.4484 3.125C16.7181 3.125 9.17842 8.03468 5.50781 15.1805L12.7251 20.6736C14.5357 15.3993 19.5456 11.5833 25.4484 11.5833Z"
        fill="#EB4335"
      />
    </svg>
  );
};

export const FacebookIcon = () => {
  return (
    <svg
      width="50"
      height="50"
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_3124_16067)">
        <path
          d="M50 25C50 11.1929 38.8071 0 25 0C11.1929 0 0 11.1929 0 25C0 37.478 9.14209 47.8208 21.0938 49.6963V32.2266H14.7461V25H21.0938V19.4922C21.0938 13.2266 24.8262 9.76562 30.5366 9.76562C33.271 9.76562 36.1328 10.2539 36.1328 10.2539V16.4062H32.9805C29.875 16.4062 28.9062 18.3335 28.9062 20.3125V25H35.8398L34.7314 32.2266H28.9062V49.6963C40.8579 47.8208 50 37.478 50 25Z"
          fill="#1877F2"
        />
        <path
          d="M34.7314 32.2266L35.8398 25H28.9062V20.3125C28.9062 18.3354 29.875 16.4062 32.9805 16.4062H36.1328V10.2539C36.1328 10.2539 33.272 9.76562 30.5366 9.76562C24.8262 9.76562 21.0937 13.2266 21.0937 19.4922V25H14.7461V32.2266H21.0937V49.6963C23.6822 50.1012 26.3178 50.1012 28.9062 49.6963V32.2266H34.7314Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_3124_16067">
          <rect width="50" height="50" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const AppleIcon = () => {
  return (
    <svg
      width="50"
      height="50"
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M46.875 25C46.875 37.075 37.0859 46.875 25 46.875C12.9141 46.875 3.125 37.075 3.125 25C3.125 12.9141 12.9141 3.125 25 3.125C37.0859 3.125 46.875 12.9141 46.875 25Z"
        fill="#283544"
      />
      <path
        d="M35.2533 19.4647C35.1339 19.5343 32.2923 21.0039 32.2923 24.2623C32.4262 27.9783 35.8783 29.2814 35.9375 29.2814C35.8783 29.3511 35.4163 31.0567 34.0479 32.8446C32.9619 34.3847 31.7566 35.9375 29.9262 35.9375C28.1852 35.9375 27.5601 34.9111 25.5512 34.9111C23.3938 34.9111 22.7834 35.9375 21.1316 35.9375C19.3012 35.9375 18.0066 34.3015 16.8614 32.7759C15.3736 30.7791 14.109 27.6455 14.0644 24.6367C14.0343 23.0423 14.3623 21.475 15.195 20.1438C16.3703 18.2854 18.4685 17.0238 20.7599 16.9822C22.5155 16.927 24.078 18.1054 25.1494 18.1054C26.1762 18.1054 28.0959 16.9822 30.2678 16.9822C31.2053 16.9831 33.7054 17.2463 35.2533 19.4647ZM25.0009 16.6639C24.6884 15.2079 25.5512 13.7519 26.3548 12.8231C27.3816 11.6999 29.0033 10.9375 30.4018 10.9375C30.4911 12.3935 29.9253 13.8215 28.914 14.8615C28.0066 15.9847 26.4441 16.8303 25.0009 16.6639Z"
        fill="white"
      />
    </svg>
  );
};

export const CloseIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="stroke-main-light dark:stroke-main-dark bg-navBG dark:bg-white/10 rounded-3xl"
    >
      <path
        d="M21 11L11 21M11 11L21 21"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
